import React from "react";
import { ReactComponent as RefundIcon } from '../assets/icons/refund.svg';
import "./app-modal-refund-transaction.scss";
import {StatusType } from "../types/statistics.types";
import AppInput from "./form/base/app-input";
import { getColorByNextStatusType } from "../utils/constants";

interface AppModalRefundProps {
  text: string;
  id: string;
  confirmLabel: string;
  cancelLabel: string;
  confirmAction: (id: string, status: StatusType, refundId?: string) => Promise<void>;
  cancelAction: () => void;
  isVisible: boolean;
  status: StatusType;
  refundId: string;
  setRefundId: (refundId: string) => void;
  action: string
}

const AppModalRefund: React.FC<AppModalRefundProps> = ({
  text,
  id,
  confirmLabel,
  cancelLabel,
  confirmAction,
  cancelAction,
  isVisible,
  status,
  refundId,
  setRefundId,
  action
}) => {
  if (!isVisible) return null;
  console.log(action, "MODAL ACTION")
  const statusColor = getColorByNextStatusType(status);

  return (
    <div className="app-modal-transaction-overlay">
      <div className="app-modal">
        <div className="modal-icon">
          <RefundIcon color={statusColor} />
        </div>
        <div className="modal-content">
          <p className="modal-text">
            {text}
            <span style={{ color: statusColor }}>{status}</span>?
          </p>
          <p className="modal-id">Transaction {id}</p>
          {action === "UPDATE_STATUS" && status === StatusType.REFUNDED && (
            <AppInput
              theme='filter'
              value={refundId}
              placeholder='Refund Id'
              onChange={(event) => {
                setRefundId(event.target.value)
              }}
            />)}
        </div>
        <div className="modal-actions">
          <button
            className="btn btn-cancel"
            onClick={cancelAction}>
            {cancelLabel}
          </button>
          <button
            className="btn btn-confirm"
            onClick={() => (confirmAction(id, status, refundId), setRefundId(""))}
            style={{ backgroundColor: statusColor }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppModalRefund;
